<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="productDetailCartInfo.orders" border style="width: 100%" size="small">
        <el-table-column prop="orderId" label="订单号" align="center" />

        <el-table-column label="商品名称" align="center">
          <template slot-scope="scope">
            <div v-for="(cart, cIndex) in scope.row.storeOrderCartDtos" :key="cIndex">{{ cart.prodName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="购买数量" align="center">
          <template slot-scope="scope">
            <div v-for="(cart, cIndex) in scope.row.storeOrderCartDtos" :key="cIndex">{{ cart.cartNum }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="appName" label="平台" align="center" />
        <el-table-column label="类型" align="center">
          <template #default="{ row }">
            {{ row.cartType == '3307' ? '服务' : '商品' }}
          </template>
        </el-table-column>
        <el-table-column prop="personName" label="用户名称" align="center" />
        <el-table-column prop="payPrice" label="支付金额" align="center" />
        <el-table-column prop="deduction" label="优惠金额" align="center">
          <template #default="{ row }">
            {{ row.deduction || 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="stateName" label="订单状态" align="center" />
        <el-table-column prop="createTime" label="创建时间" align="center" />
      </el-table>

      <el-row class="margin-top">
        <el-col :span="12"></el-col>
        <el-col :span="12" class="text-right">
          <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryStoreOrder } from '@/api/goods/productDetailApi'
export default {
  name: 'ProductDetailCart',
  data() {
    return {
      productDetailCartInfo: {
        orders: [],
        productId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.productDetailCartInfo.productId = params.productId
      this.loadProductDetailCartData()
    },
    async loadProductDetailCartData() {
      const res = await queryStoreOrder({
        productId: this.productDetailCartInfo.productId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize,
        shopId: getShopId()
      })
      this.productDetailCartInfo.orders = res.data
      this.pagination.total = res.records
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadProductDetailCartData()
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>